import tw from 'twin.macro';

/**
 * PageWrapper
 * Main container for the student home page.
 * Sets background color, padding, font, and ensures full viewport height.
 */
export const PageWrapper = tw.div`relative bg-gray-100 md:bg-white
pt-16 lg:px-20 px-4 overflow-x-hidden font-display h-screen`;

/**
 * TimetableWrap
 * Container for the timetable section.
 * White background, responsive padding, and negative top margin for spacing.
 */
export const TimetableWrap = tw.div`bg-white -mt-4 lg:pb-8 pb-4 lg:pt-20! pt-10! px-2 lg:px-4`;

/**
 * PageHeaderWrap
 * Wrapper for the page header.
 * Responsive width, flex layout, left margin, and bottom margin.
 */
export const PageHeaderWrap = tw.div`lg:w-5/7 flex items-center justify-between lg:ml-10 mb-4`;

/**
 * Title
 * Styles for the timetable title.
 * Centered, uppercase, bold, and responsive font size and padding.
 */
export const Title = tw.h4`text-center lg:text-xl text-lg uppercase
 lg:py-8 md:py-6 py-4 font-semibold`;

/**
 * Row
 * Container for each row in the timetable.
 * Responsive width, flex layout, vertical padding, and bottom border except last row.
 */
export const Row = tw.div`lg:w-7/12 mx-auto flex justify-between py-2 md:py-4
 border-b border-gray-300 lg:py-8 last:border-none`;

/**
 * Details
 * List container for student and paper details.
 * Responsive font size and bold.
 */
export const Details = tw.ul`lg:text-xl text-sm font-semibold`;

/**
 * DetailItem
 * List item for each detail (e.g., name, course, time).
 * Responsive vertical margin.
 */
export const DetailItem = tw.li`lg:my-1`;

/**
 * DetailItemkey
 * Span for the key/label part of a detail (e.g., "Name", "Course").
 * Uses primary color for emphasis.
 */
export const DetailItemkey = tw.span`text-primary`;

/**
 * DetailItemValue
 * Span for the value part of a detail.
 * (No extra styling, but exported for consistency.)
 */
export const DetailItemValue = tw.span``;

/**
 * QRcode
 * Styles for the QR code image.
 * Responsive width and height.
 */
export const QRcode = tw.img`lg:w-52 lg:h-52 w-20 h-24`;

/**
 * PrintButton
 * Container for the print button.
 * Absolutely/fixed positioned at the bottom right, with bold white text.
 */
export const PrintButton = tw.div`absolute text-white lg:bottom-16 lg:right-50 
bottom-[5.5rem] right-6 font-bold fixed`;
